import React from "react";
import PropTypes from "prop-types";

const DottedLine = ({ number }) => (
    <svg
        className={`step-tip__line step-tip__line--${number}`}
        width="93px"
        height="93px"
        viewBox="0 0 93 93"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g
            id="V2_Design"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeDasharray="5,3"
            strokeOpacity="0.5"
        >
            <g
                id="3things_pink-w-face-copy-20"
                transform="translate(-435.000000, -844.000000)"
                stroke="#ED255B"
            >
                <path
                    d="M528,844 C477.189803,844 436,885.189803 436,936"
                    id="Oval-3"
                    transform="translate(482.000000, 890.000000) rotate(-90.000000) translate(-482.000000, -890.000000) "
                />
            </g>
        </g>
    </svg>
);

DottedLine.propTypes = {
    number: PropTypes.string
};

export default DottedLine;



// WEBPACK FOOTER //
// ./src/components/svgs/DottedLine.jsx